import { useEffect, useState } from "react";
import Card from "../../../Card/Card";
import classes from "./RequestPayout.module.css";
import InputField from "../../../InputField/InputField";
import DropdownIcon from "../../../../icon/DropDownIcon";
import PencilEditIcon from "../../../../icon/PencilEditIcon";
import CheckIcon from "../../../../icon/CheckIcon";
import axios from "axios";
import { env } from "../../../../constants/env";
import { toast } from "react-toastify";
import useWindowDimensions from "../../../../hooks/getWindowDimensions";

const noteList = [
  [
    {
      title: "Withdrawal Method",
      desc: "Withdrawals are processed exclusively via the USDT ERC/TRC network.",
    },
    {
      title: "Automatic Processing",
      desc: "Withdrawals below (XYZ) are handled automatically by the blockchain. Completion time may vary from minutes to hours depending on network congestion.",
    },
    {
      title: "Manual Approval",
      desc: "Withdrawals exceeding (XYZ) require manual approval for security reasons. This process ensures protection against potential pool exploits and is completed within 24 hours.",
    },
  ],
  [
    {
      title: "Irreversible Transactions",
      desc: "Withdrawals are final and cannot be reversed. Please double-check your wallet address and withdrawal amount before confirming.",
    },
    {
      title: "Learn More",
      desc: (
        <>
          For detailed information about withdrawal terms and conditions,{" "}
          <a href="#">visit here.</a>
        </>
      ),
    },
  ],
];

const percentList = [
  {
    text: "25%",
    amount: 0.25,
  },
  {
    text: "50%",
    amount: 0.5,
  },
  {
    text: "75%",
    amount: 0.75,
  },
  {
    text: "100%",
    amount: 1,
  },
];

const coinsList = [
  {
    name: "Ethereum - ETH",
    tag: "",
  },
  {
    name: "Bitcoin - BTC",
    tag: "",
  },
  {
    name: "USDT",
    tag: "",
  },
];

const networkList = [
  {
    name: "ERC20",
    tag: "",
  },
  {
    name: "TRC2O",
    tag: "",
  },
];

const RequestPayout = ({ profitAmount, setWithdrawalSuccess, refer }) => {
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [activePercentage, setActivePercentage] = useState(null);
  const [activeStep, setActiveStep] = useState(1);
  const [selectedCoin, setSelectedCoin] = useState("USDT");
  const [showCoinDropDown, setShowCoinDropDown] = useState(false);
  const [showNetworkDropDown, setShowNetworkDropDown] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [walletAddress, setWalletAddress] = useState("");
  const [activatButton, setActivatButton] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { height, width } = useWindowDimensions();

  const [checked, setChecked] = useState(false);

  const toggleCheckbox = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    if (
      activeStep === 1 &&
      withdrawalAmount <= profitAmount &&
      withdrawalAmount > 0 && withdrawalAmount !== ""
    ) {
      setActivatButton(true);
    } else if (
      activeStep === 2 &&
      selectedNetwork &&
      selectedCoin &&
      walletAddress.length > 1
    ) {
      setActivatButton(true);
    } else if ((activeStep === 3 && checked)  || (activeStep === 3 && refer)) {
      setActivatButton(true);
    }
  }, [
    activeStep,
    withdrawalAmount,
    selectedNetwork,
    selectedCoin,
    walletAddress,
    checked,
  ]);

  const handleSubmit = async (e) => {
    if (!withdrawalAmount || withdrawalAmount <= 0) {
      setError("Please enter a valid withdrawal amount.");
      return;
    }

    if (!walletAddress) {
      setError("Please provide a valid wallet address.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${env.apiUrl}/api/withdraw`,
        {
          amount: withdrawalAmount,
          coin: selectedCoin + " " + selectedNetwork,
          to: walletAddress,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setMessage(response.data.message);
      setWithdrawalAmount("");
      setWalletAddress("");
      setWithdrawalSuccess(true);
    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
      toast.error(err.response?.data?.message)
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReferSubmit = async () => {
    console.log("CLICKED")
    try{
      const response = await axios.post(
        `${env.apiUrl}/api/commissions/request`,
        { 
          amount: withdrawalAmount,
          method: selectedCoin + " (" + selectedNetwork + ")", 
          address: walletAddress
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setWithdrawalSuccess(true);
    }catch(err){
      setError(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
      toast.error(err.response?.data?.message)
    }
    
  }
  return (
    <div className={classes.wrapper}>
      <div>
        <Card className={(width <= 768 && activeStep !== 1) ? classes.card : ""}>
          {activeStep === 1 && (
            <div
              className={`${classes.payoutInput} d-flex align-items-center justify-content-between`}
            >
              <input
                placeholder="Enter amount"
                value={withdrawalAmount}
                onChange={(e) => setWithdrawalAmount(e.target.value)}
              />{" "}
              {width > 768 && <div
                className={`${classes.percentageWrapper} d-flex align-items-center`}
              >
                {percentList.map((item, i) => (
                  <div
                    className={`${classes.percentageButton} ${
                      i !== 3 ? classes.percentageBorder : ""
                    } ${
                      i === activePercentage ? classes.activePercentage : ""
                    } d-flex align-items-center justify-content-center`}
                    key={i}
                    role="button"
                    onClick={() => {
                      if (i === activePercentage) {
                        setWithdrawalAmount("");
                        setActivePercentage(null);
                      } else {
                        setWithdrawalAmount(profitAmount * item.amount);
                        setActivePercentage(i);
                      }
                    }}
                  >
                    {item.text}
                  </div>
                ))}
              </div>}
            </div>
          )}
          {(activeStep === 2 || activeStep === 3) && (
            <div className={`${classes.inputWrapper} row`}>
              <div className="col-md-6 ">
                <InputField
                  innerClass={`${classes.inputContainer} ${
                    classes.selectContainer
                  } ${classes.unselected} ${
                    activeStep === 3 ? classes.disabledInput : ""
                  } ${activeStep === 3 ? classes.finalField : ""}`}
                  label={activeStep === 2 && "Coin"}
                  icon={
                    activeStep === 2 ? (
                      <DropdownIcon />
                    ) : (
                      <div className={classes.valueContainer}>
                        {selectedCoin}
                      </div>
                    )
                  }
                  // onClick={() => activeStep === 2 && setShowCoinDropDown(true)}
                  // role={activeStep === 2 && "button"}
                >
                  {activeStep === 2
                    ? selectedCoin
                      ? selectedCoin
                      : "USDT"
                    : "Coin"}
                </InputField>
                <div className={classes.inputInnerWrapper}>
                  {showCoinDropDown && (
                    <Card
                      className={`${classes.dropDownCard} width <= 768 && activeStep === 1 d-flex flex-column gap-3`}
                    >
                      {coinsList.map((item, i) => (
                        <>
                          {item.name !== selectedCoin && (
                            <div
                              key={i}
                              role="button"
                              onClick={() => {
                                setSelectedCoin(item.name);
                                setShowCoinDropDown(false);
                              }}
                            >
                              {item.name}
                            </div>
                          )}
                        </>
                      ))}
                    </Card>
                  )}
                </div>
              </div>
              <div className="col-md-6 mt-2 mt-md-0">
                <div>
                  <InputField
                    label={activeStep === 2 && "Network"}
                    innerClass={`${classes.inputContainer} ${
                      !selectedNetwork ? classes.unselected : ""
                    } ${classes.selectContainer} ${
                      activeStep === 3 ? classes.finalField : ""
                    }`}
                    icon={
                      activeStep === 2 ? (
                        <DropdownIcon />
                      ) : (
                        <div className={classes.valueContainer}>
                          {selectedNetwork}
                        </div>
                      )
                    }
                    onClick={() =>
                      activeStep === 2 && setShowNetworkDropDown(true)
                    }
                    role={activeStep === 2 && "button"}
                  >
                    {activeStep === 2
                      ? selectedNetwork
                        ? selectedNetwork
                        : "Select network"
                      : "Network"}
                  </InputField>
                  <div className={classes.inputInnerWrapper}>
                    {showNetworkDropDown && (
                      <Card
                        className={`${classes.dropDownCard} d-flex flex-column gap-3`}
                      >
                        {networkList.map((item, i) => (
                          <>
                            {item.name !== selectedNetwork && (
                              <div
                                key={i}
                                role="button"
                                onClick={() => {
                                  setSelectedNetwork(item.name);
                                  setShowNetworkDropDown(false);
                                }}
                              >
                                {item.name}
                              </div>
                            )}
                          </>
                        ))}
                      </Card>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-2">
                <InputField
                  innerClass={`${classes.inputContainer} ${
                    activeStep === 3 ? classes.finalField : ""
                  }`}
                  label="Wallet address"
                  icon={
                    activeStep === 3 && (
                      <div className="d-flex align-items-center gap-2">
                        <div className={classes.valueContainer}>
                          {walletAddress}
                        </div>
                        {!refer && <PencilEditIcon />}
                      </div>
                    )
                  }
                  placeholder="Enter wallet address"
                  value={walletAddress}
                  onChange={(e) => setWalletAddress(e.target.value)}
                  disabled={activeStep === 3}
                >
                  {activeStep === 3 && "Wallet Address"}
                </InputField>
              </div>
            </div>
          )}
        </Card>

        {(width <= 768 && activeStep === 1) && <div className="d-flex justify-content-center mt-4 ">
        <div
              className={`${classes.percentageWrapper} d-flex align-items-center`}
            >
              {percentList.map((item, i) => (
                <div
                  className={`${classes.percentageButton} ${
                    i !== 3 ? classes.percentageBorder : ""
                  } ${
                    i === activePercentage ? classes.activePercentage : ""
                  } d-flex align-items-center justify-content-center`}
                  key={i}
                  role="button"
                  onClick={() => {
                    if (i === activePercentage) {
                      setWithdrawalAmount("");
                      setActivePercentage(null);
                    } else {
                      setWithdrawalAmount(profitAmount * item.amount);
                      setActivePercentage(i);
                    }
                  }}
                >
                  {item.text}
                </div>
              ))}
            </div></div>}
        <div
          className={`d-flex justify-content-between ${classes.requestBottom}`}
        >
          <div>
            {activeStep === 1 && withdrawalAmount > +profitAmount && (
              <div className={classes.errorContainer}>
                You don’t have enough funds for this transaction
              </div>
            )}
            {(activeStep === 3 && !refer) && (
              <div
                className={`${classes.checkboxWrapper} d-flex align-items-center gap-2`}
              >
                <div
                  onClick={toggleCheckbox}
                  className={`${classes.checkboxContainer} ${
                    checked ? classes.checked : ""
                  }`}
                >
                  {checked && <CheckIcon />}
                </div>
                I confirm that the above details are correct
              </div>
            )}
            {(refer && (activeStep === 3 || activeStep === 2)) && <button className={classes.previousButton} onClick={() => {
                  if (activeStep === 2) {
                    setActiveStep(1);
                  } else if (activeStep === 3) {
                    setActiveStep(2);
                  }
                }}>Previous</button>}
          </div>
          <div
            className={`${classes.navContainer} d-flex align-items-center gap-2`}
          >
            <div>{activeStep}/3</div>
            {!isSubmitting && (
              <button
                className={activatButton ? classes.activeButton : ""}
                disabled={!activatButton}
                onClick={() => {
                  if (activeStep === 1) {
                    setActiveStep(2);
                    setActivatButton(false);
                  } else if (activeStep === 2) {
                    setActiveStep(3);
                    setActivatButton(false);
                  } else if (activeStep === 3) {
                    if(refer){
                      handleReferSubmit();
                    }else{handleSubmit();}
                  }
                }}
              >
                {activeStep === 3 ? "Submit request" : "Next"}
              </button>
            )}
            {isSubmitting && (
              <div
                className={`d-flex align-items-center justify-content-center ${classes.wrapper}`}
              >
                <div className="spinner-border text-light" role="status"></div>
              </div>
            )}
          </div>
        </div>
      </div>

      {!refer && <Card className={classes.noteCard}>
        <h4>Important note</h4>
        <div className="row">
          {noteList.map((list, i) => (
            <div
              className={`col-6 ${classes.listWrapper} ${
                i === 0 ? classes.firstList : classes.secondList
              }`}
              key={i}
            >
              <ul>
                {list.map((item, index) => (
                  <li key={index}>
                    {item.title}
                    <p>{item.desc}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Card>}
    </div>
  );
};

export default RequestPayout;
